
import React from "react";
import { BodyPhotoShareDto } from "../../../../../types/types";

interface BodyPhotoShareProps {
  share: BodyPhotoShareDto;
}

const BodyPhotoShare: React.FC<BodyPhotoShareProps> = ({ share }) => {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 8px",
        background: "#e8ffe6",
        borderRadius: 16,
        fontSize: 13,
        color: "#1f7a1f",
        border: "1px solid #b6e3b6"
      }}
      title={`Shared with user ${share.userId}`}
    >
      {share.name}
    </span>
  );
};

export default BodyPhotoShare;
